import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailLabel} from '../mapping-classes/detail-label';
import {DetailPanel} from '../mapping-classes/detail-panel';

export class Bankguarantee implements DetailScreen {
  restrictedData: boolean;
  title: string;
  buttons;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;
  liabilityCurrentAmountString = 'liability-currentAmount-smallestUnitAmount';
  liabilityCurrentAmountInEURString = 'liability-currentAmountInEUR-smallestUnitAmount';
  openingAmountInEURString = 'openingAmountInEUR-smallestUnitAmount';
  openingAmountString = 'openingAmount-smallestUnitAmount';
  feeGuaranteeCommissionPercentageString = 'fee-guaranteeCommission-percentage';

  constructor(response: any) {
    this.title = 'Bankgarantie';
    if (response.listOfError && response.listOfError.length !== 0) {
      this.createErrorMessage(response);
    } else {
      this.restrictedData = response.detailsViewObject['restrictedData'];
      this.panels = [];
      this.nameValues = [];
      this.buttons = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private nullSafe<T>(someObject: T, defaultValue: T = {} as T): T {
    if (typeof someObject === 'undefined' || someObject === null) {
      return defaultValue;
    }
    return someObject;
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Productgebruik'));
  }

  setNameAndValues() {
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.fillProductDetailsPanel(productDetailsPanel);

    const productAgreementsPanel: DetailPanel = this.panels[1];
    this.fillProductAgreementsPanel(productAgreementsPanel);

    const productUsePanel: DetailPanel = this.panels[2];
    this.fillProductUsePanel(productUsePanel);

  }

  addValues(response) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);
    const productAgreementsPanel: DetailPanel = this.panels[1];
    this.addValuesToProductAgreementsPanel(productAgreementsPanel, obj);
    const productUsePanel: DetailPanel = this.panels[2];
    this.addValuesToProductUsePanel(productUsePanel, obj);
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('referenceNumber', new DetailLabel('Referentienummer'));
    productDetailsPanel.nameAndValues.set('guaranteeType', new DetailLabel('Soort garantie'));
    productDetailsPanel.nameAndValues.set('applicant-partyName', new DetailLabel('Opdrachtgever'));
    productDetailsPanel.nameAndValues.set('handlingType', new DetailLabel('Wijze gesteld'));
    productDetailsPanel.nameAndValues.set('accountee-partyName', new DetailLabel('Debiteur'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('referenceNumber').setValue(obj.referenceNumber);
    productDetailsPanel.nameAndValues.get('guaranteeType').setValue(obj.guaranteeType);
    productDetailsPanel.nameAndValues.get('applicant-partyName').setValue(this.nullSafe(obj.applicant).partyName);
    productDetailsPanel.nameAndValues.get('handlingType').setValue(obj.handlingType);
    productDetailsPanel.nameAndValues.get('accountee-partyName').setValue(this.nullSafe(obj.accountee).partyName);
  }

  private fillProductAgreementsPanel(productAgreementsPanel: DetailPanel) {
    productAgreementsPanel.nameAndValues.set('startDate', new DetailLabel('Openingsdatum'));
    productAgreementsPanel.nameAndValues.set(this.openingAmountInEURString, new DetailLabel('Garantiebedrag'));
    productAgreementsPanel.nameAndValues.set('issuingBank-partyName', new DetailLabel('Issuing bank'));
    productAgreementsPanel.nameAndValues.set('expirationDate', new DetailLabel('Vervaldatum'));
    productAgreementsPanel.nameAndValues.set(this.openingAmountString, new DetailLabel('Garantiebedrag VV'));
    productAgreementsPanel.nameAndValues.set('beneficiary-partyName', new DetailLabel('Begunstigde'));
    productAgreementsPanel.nameAndValues.set('endDate', new DetailLabel('Einddatum'));
    productAgreementsPanel.nameAndValues.set(this.feeGuaranteeCommissionPercentageString, new DetailLabel('Bankgarantieprovisie'));
    productAgreementsPanel.nameAndValues.set('beneficiary-riskCountryCode', new DetailLabel('Land'));
    productAgreementsPanel.nameAndValues.set('fee-confirmationCommission-percentage', new DetailLabel('Confirmatieprovisie'));
  }

  private addValuesToProductAgreementsPanel(productAgreementsPanel: DetailPanel, obj) {
    productAgreementsPanel.nameAndValues.get('startDate').setValue(obj.startDate);
    productAgreementsPanel.nameAndValues.get('issuingBank-partyName')
      .setValue(this.nullSafe(this.nullSafe(obj.issuingBank).partyName, null));
    productAgreementsPanel.nameAndValues.get('beneficiary-partyName')
      .setValue(this.nullSafe(this.nullSafe(obj.beneficiary).partyName, null));
    productAgreementsPanel.nameAndValues.get('endDate').setValue(obj.endDate);
    productAgreementsPanel.nameAndValues.get(this.feeGuaranteeCommissionPercentageString)
      .setValue(this.nullSafe(this.nullSafe(this.nullSafe(obj.fee).guaranteeCommission).percentage, null));
    productAgreementsPanel.nameAndValues.get(this.feeGuaranteeCommissionPercentageString).setType('percentage');
    productAgreementsPanel.nameAndValues.get('beneficiary-riskCountryCode')
      .setValue(this.nullSafe(this.nullSafe(obj.beneficiary).riskCountryCode, null));
    productAgreementsPanel.nameAndValues.get('fee-confirmationCommission-percentage')
      .setValue(this.nullSafe(this.nullSafe(this.nullSafe(obj.fee).confirmationCommission).percentage, null));
    productAgreementsPanel.nameAndValues.get('fee-confirmationCommission-percentage').setType('percentage');

    if (this.restrictedData) {
      productAgreementsPanel.nameAndValues.get(this.openingAmountInEURString).setValue(this.shieldedText);
      productAgreementsPanel.nameAndValues.get(this.openingAmountString).setValue(this.shieldedText);
    } else {
      productAgreementsPanel.nameAndValues.get(this.openingAmountInEURString)
        .setValue(this.nullSafe(this.nullSafe(obj.openingAmountInEUR).smallestUnitAmount, null));
      productAgreementsPanel.nameAndValues.get(this.openingAmountInEURString).setType('amount');
      productAgreementsPanel.nameAndValues.get(this.openingAmountString)
        .setValue(this.nullSafe(this.nullSafe(obj.openingAmount).smallestUnitAmount, null));
      productAgreementsPanel.nameAndValues.get(this.openingAmountString).setType('foreignAmount');
      productAgreementsPanel.nameAndValues.get(this.openingAmountString)
        .setCurrencyCode(this.nullSafe(this.nullSafe(obj.openingAmount).currencyCode, null));
    }

    if (obj['unlimitedValidity']) {
      productAgreementsPanel.nameAndValues.get('expirationDate').setValue('Ongelimiteerd');
    } else {
      productAgreementsPanel.nameAndValues.get('expirationDate').setValue(obj['expirationDate']);
    }
  }

  private fillProductUsePanel(productUsePanel: DetailPanel) {
    productUsePanel.nameAndValues.set(this.liabilityCurrentAmountInEURString, new DetailLabel('Openstaand bedrag'));
    productUsePanel.nameAndValues.set(this.liabilityCurrentAmountString, new DetailLabel('Openstaand bedrag VV'));
    productUsePanel.nameAndValues.set('liability-account-formattedIban', new DetailLabel('Rekening ingeperkt'));
    productUsePanel.nameAndValues.set('fee-account-formattedIban', new DetailLabel('Kosten afgerekend op'));
  }

  private addValuesToProductUsePanel(productUsePanel: DetailPanel, obj) {
    productUsePanel.nameAndValues.get('liability-account-formattedIban')
      .setValue(this.nullSafe(this.nullSafe(this.nullSafe(obj.liability).account).formattedIban, null));
    productUsePanel.nameAndValues.get('fee-account-formattedIban')
      .setValue(this.nullSafe(this.nullSafe(this.nullSafe(obj.fee).account).formattedIban, null));

    if (this.restrictedData) {
      productUsePanel.nameAndValues.get(this.liabilityCurrentAmountInEURString).setValue(this.shieldedText);
      productUsePanel.nameAndValues.get(this.liabilityCurrentAmountString).setValue(this.shieldedText);
    } else {
      productUsePanel.nameAndValues.get(this.liabilityCurrentAmountInEURString)
        .setValue(this.nullSafe(this.nullSafe(this.nullSafe(obj.liability).currentAmountInEUR).smallestUnitAmount, null));
      productUsePanel.nameAndValues.get(this.liabilityCurrentAmountInEURString).setType('amount');
      productUsePanel.nameAndValues.get(this.liabilityCurrentAmountString)
        .setValue(this.nullSafe(this.nullSafe(this.nullSafe(obj.liability).currentAmount).smallestUnitAmount, null));
      productUsePanel.nameAndValues.get(this.liabilityCurrentAmountString).setType('foreignAmount');
      productUsePanel.nameAndValues.get(this.liabilityCurrentAmountString)
        .setCurrencyCode(this.nullSafe(this.nullSafe(this.nullSafe(obj.liability).currentAmount).currencyCode, null));
    }
  }
}
